module.exports = __webpack_public_path__ + "img/anfang.ec99d4fc.png";